import { money } from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Pencil, PauseCircle, Trash2 } from "lucide-react";

// Active/closed deal management grid. State/handlers come from AdminDashboard.
export const DealsTab = ({ deals, openEdit, closeDeal, deleteDeal }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    {deals.filter((d) => d.status !== "pending").map((d) => (
      <div key={d.deal_id} data-testid={`admin-deal-${d.deal_id}`} className="rounded-xl border border-black/10 bg-white overflow-hidden">
        <img src={d.image_url} alt="" className="h-32 w-full object-cover" />
        <div className="p-4">
          <div className="flex items-center justify-between">
            <Badge className={d.status === "active" ? "bg-accent/10 text-accent border-none" : "bg-secondary text-muted-foreground border-none"}>
              {d.status}
            </Badge>
            <span className="text-sm font-semibold">{money(d.original_price)}</span>
          </div>
          <h3 className="mt-2 font-heading text-base leading-snug" style={{ fontWeight: 600 }}>{d.title}</h3>
          <p className="text-xs text-muted-foreground">{d.retailer}</p>
          {d.updated_at && (
            <p className="mt-0.5 text-[11px] text-muted-foreground/80">
              Edited {(d.updated_at || "").slice(0, 10)}{d.last_edited_by_name ? ` by ${d.last_edited_by_name}` : ""}
              {d.edited_since_review ? " · needs review" : ""}
            </p>
          )}
          <div className="mt-2 flex items-center gap-1">
            <Button
              variant="outline" size="sm" data-testid={`edit-deal-${d.deal_id}`}
              onClick={() => openEdit(d)}
              className="rounded-full border-black/20"
            >
              <Pencil className="mr-1 h-3.5 w-3.5" /> Edit
            </Button>
            {d.status === "active" && (
              <Button
                variant="ghost" size="sm" data-testid={`close-deal-${d.deal_id}`}
                onClick={() => closeDeal(d.deal_id)}
                className="text-muted-foreground hover:bg-secondary"
              >
                <PauseCircle className="mr-1 h-3.5 w-3.5" /> Close
              </Button>
            )}
            <Button
              variant="ghost" size="sm" data-testid={`delete-deal-${d.deal_id}`}
              onClick={() => deleteDeal(d)}
              className="text-destructive hover:text-destructive hover:bg-destructive/10"
            >
              <Trash2 className="mr-1 h-3.5 w-3.5" /> Delete
            </Button>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default DealsTab;
